import { useEffect, useState } from "react";
import { SIM_BUILDER_API_END_POINT } from "../Config";
import { useParams } from "react-router-dom";
import TopNavForPublic from "./generic/TopNavForPublic";
import $ from "jquery";
import ReportService from "../services/ReportService";
import LoaderComponent from "./loader";

const SimulationFeedbackReport = () => {
  const { simPlayedSummaryId } = useParams();
  const [isShowLoader, setIsShowLoader] = useState(true);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");

  const generateFeedbackReport = async () => {
    if (simPlayedSummaryId) {
      setIsShowLoader(true);
      await ReportService()
        .getFeedbackReport(
          `${SIM_BUILDER_API_END_POINT}/reports/feedbackReport/${simPlayedSummaryId}`
        )
        .then((response) => {
          if (response?.status === 204) {
            setIsShowLoader(false);
            setShowMessage(true);
            setMessage(
              <p>Your simulation feedback report is currently in progress. Please access the same link again after some time.</p>
            );
          }else if (response?.status === 205) {
            setIsShowLoader(false);
            setShowMessage(true);
            setMessage(
              <p>The file you are trying to access may not exist. Kindly contact the administrator at <span className='color-blue'>cx@schoolsims.com</span> for further assistance.</p>
            );
          }
           else {
            var blob = new Blob([response.data], { type: "application/pdf" }),
              url = URL.createObjectURL(blob),
              _iFrame = document.createElement("iframe");

            _iFrame.setAttribute("src", url);
            _iFrame.setAttribute(
              "style",
              "visibility:visible;width:100%;height:700px"
            );
            $("#reportDiv").append(_iFrame);
            setIsShowLoader(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching feedback report:", error);
          setIsShowLoader(false);
        });
    }
  };

  useEffect(() => {
    generateFeedbackReport();
  }, [simPlayedSummaryId]);

  return (
    <>
      <link href="/simFeedback.css" rel="stylesheet" />
      <TopNavForPublic />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <section className="simulation-header p-0">
              <h3 className="title">Simulation Feedback Report</h3>
            </section>
          </div>
          {!showMessage && (
            <div className="col-md-12 text-center mt-3">
              <p>
                Congratulations on completing the simulation. Let's take a look
                and see how you did!
              </p>
            </div>
          )}

          <div className="col col-12" id="reportDiv"></div>
          {showMessage && (
            <div className="col col-12 text-center mt-3">
              {message}
            </div>
          )}
        </div>
        {isShowLoader && (
          <div className="overlay">
            <LoaderComponent />
          </div>
        )}
      </div>
    </>
  );
};

export default SimulationFeedbackReport;
